import React from 'react';
import { Grid as MuiGrid } from '@mui/material';
import type { GridProps } from '@mui/material';

// Enhanced Grid props that properly supports the 'item' prop in Material UI v7
// and includes common sizing props used throughout the project
interface EnhancedGridProps extends GridProps {
  item?: boolean;
  xs?: number | boolean;
  sm?: number | boolean;
  md?: number | boolean;
  lg?: number | boolean;
  xl?: number | boolean;
  spacing?: number;
  container?: boolean;
  direction?: 'row' | 'row-reverse' | 'column' | 'column-reverse';
  alignItems?: 'flex-start' | 'center' | 'flex-end' | 'stretch' | 'baseline';
  justifyContent?: 'flex-start' | 'center' | 'flex-end' | 'space-between' | 'space-around' | 'space-evenly';
}

// Create a Grid component wrapper that handles MUI v7 compatibility
export const Grid: React.FC<EnhancedGridProps> = (props) => {
  // Pass all props to MuiGrid - our interface ensures type safety
  return <MuiGrid {...props} />;
};

export default Grid;